import ColorService from 'Services/ColorService'
import BaseCell from './BaseCell'

dotSize = 12
dotRadius = dotSize / 2

export default AnchorCell = ({
  columnIndex,
  rowIndex,
  style,
  ...rest
}) ->

  r = -1
  c = -1

  <BaseCell
    rowIndex={r}
    colIndex={c}
    onClick={(e) ->
      e.stopPropagation()
    }
    style={style}
  >
    <svg
      width={dotSize}
      height={dotSize}
      style={{ lineHeight: 30, position: 'relative' }}
    >
      <circle
        cx={dotRadius}
        cy={dotRadius}
        r={dotRadius}
        fill={ColorService.getColorForType(viewConfig?.subject)}
      />
    </svg>
  </BaseCell>